import React, { useState } from 'react';
import { I18n, T } from '@deity/falcon-i18n';
import { Form, FormSubmit } from '@deity/falcon-ui-kit';
import { ErrorMessage, Field } from 'formik';
import { Radio } from '../../../ui/Radio/Radio';
import { FormField } from '../../../ui/Forms/FormField';
import withStoreConfiguration from '../../../helpers/StoreConfiguration/StoreConfiguration';
import { Button } from '../../../ui/Button/Button';
import { Errors } from '../../Errors/Errors';
import { Checkbox } from '../../../ui/Checkbox/Checkbox';
import loadable from '../../../../../../components/loadable';
import { PrefixFormProvider } from './PrefixFormProvider';
import styles from './PrefixForm.module.scss';

const Modal = loadable(() => import(/* webpackChunkName: "general" */ '../../../ui/Modal/Modal'));

export const PrefixForm = withStoreConfiguration(({ storeConfiguration, type, code, idToken, onSuccess }) => {
  const prefixOptions = storeConfiguration?.customer?.address?.prefix_options?.split(';');
  const [showAgbOverlay, setShowAgbOverlay] = useState(false);
  const [showDataProtectionOverlay, setShowDataProtectionOverlay] = useState(false);
  const agbLabel = (
    <I18n>
      {t => (
        <span className={styles.PrefixTerms}>
          {t('signUp.registerLabel')}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <span onClick={() => setShowAgbOverlay(true)}>{t('signUp.agb')}</span>
          {t('signUp.registerLabelOne')}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <span onClick={() => setShowDataProtectionOverlay(true)}>{t('signUp.privacyPolicy')}</span>
          {t('signUp.registerLabelTwo')}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <span onClick={() => setShowDataProtectionOverlay(true)}>{t('signUp.dataProtection')}</span>.
        </span>
      )}
    </I18n>
  );
  return (
    <I18n>
      {t => (
        <PrefixFormProvider
          initialValues={{ prefix: prefixOptions[1], type, code, idToken, terms: false }}
          onSuccess={onSuccess}
        >
          {({ status = {} }) => {
            return (
              <React.Fragment>
                <p className={styles.PrefixInfo}>
                  <T id="signUp.missingData" />
                </p>
                <Form id="addPrefix">
                  <FormField
                    label={t('signUp.firstname')}
                    name="prefix"
                    required
                    className={styles.PrefixOptionsWrapper}
                  >
                    {({ form, field }) => {
                      return prefixOptions.map(item => (
                        <Radio
                          key={item}
                          name="namePrefix"
                          value={item}
                          checked={field.value === item}
                          onChange={x => form.setFieldValue(field.name, x.target.value)}
                          label={item}
                        />
                      ));
                    }}
                  </FormField>
                  <div className={styles.TermsWrapper}>
                    <ErrorMessage name="terms" />
                    <Field
                      required
                      name="terms"
                      render={({ field }) => {
                        return (
                          <Checkbox
                            name="terms"
                            id="terms"
                            buttonOnTop
                            type="checkbox"
                            checked={field.value.terms}
                            label={agbLabel}
                            {...field}
                          />
                        );
                      }}
                    />
                  </div>
                  {status.error && <Errors error={status.error} />}
                  <FormSubmit>
                    {({ form }) => {
                      return (
                        <Button type="submit" size="small" disabled={!form.values.terms} loading={form.isSubmitting}>
                          <T id="signUp.register" />
                        </Button>
                      );
                    }}
                  </FormSubmit>
                </Form>
                {showAgbOverlay ? (
                  <Modal
                    pageContent={t('cms.agb.link')}
                    variant="tertiary"
                    scrollableContent
                    visible={showAgbOverlay}
                    close={() => {
                      setShowAgbOverlay(false);
                    }}
                  />
                ) : null}
                {showDataProtectionOverlay ? (
                  <Modal
                    pageContent={t('cms.dataprotection.link')}
                    variant="tertiary"
                    scrollableContent
                    visible={showDataProtectionOverlay}
                    close={() => {
                      setShowDataProtectionOverlay(false);
                    }}
                  />
                ) : null}
              </React.Fragment>
            );
          }}
        </PrefixFormProvider>
      )}
    </I18n>
  );
});
